export default __webpack_public_path__ + "static/media/ETH-DAI.e485b310.png";